






















import mixins from 'vue-typed-mixins';
import { User } from '@/utils/UserUtils';
import EmailUtils, { AutomatedEmail } from '@/utils/EmailUtils';
export default mixins().extend({
  props: {
    user: {
      type: Object as () => User,
    },
  },

  computed: {
    emailsOptions(): any {
      return this.emails.items?.map((email) => ({
        text: email.name,
        value: email,
      }));
    },
  },

  data(): {
    visible: boolean;
    emails: {
      loading: boolean;
      items?: AutomatedEmail[];
      selected?: AutomatedEmail;
    };
  } {
    return {
      visible: false,
      emails: {
        loading: false,
        items: undefined,
        selected: undefined,
      },
    };
  },

  watch: {
    async visible(visible: boolean) {
      if (visible) {
        this.emails.selected = undefined;
      }

      if (visible && !this.emails.loading && !this.emails.items) {
        this.emails.loading = true;
        try {
          this.emails.items = (await EmailUtils.api.list()).filter(
            (email) => email.type === 'user'
          );
        } catch (error) {
          (this.$refs.alert as any).show('visible', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
        this.emails.loading = false;
      }
    },
  },

  methods: {
    handleClick() {
      this.visible = true;
    },

    async submit() {
      try {
        (this.$refs.alert as any).hide('submit');
        await EmailUtils.api.send({
          emailid: this.emails.selected?.id,
          users: [this.user]
        });
        this.visible = false;
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('page.user.details.sendEmail.success'),
        });
      } catch (error) {
        (this.$refs.alert as any).show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
